<template>
</template>

<script>
export default {
  name: 'my-auth',
  computed: {
    statusHandleAuthentication: function () {
      return this.$store.getters.statusHandleAuthentication
    },
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated
    },
    idTokenExpiresAt: function () {
      return this.$store.getters.idTokenExpiresAt
    },
    idTokenProvider: function (state) {
      return this.$store.getters.idTokenProvider
    },
    idTokenIPAuthDealerID: function (state) {
      return this.$store.getters.idTokenIPAuthDealerID
    },
    statusCheckSession: function () {
      return this.$store.getters.statusCheckSession
    }
  },
  data: function () {
    return {
      request: {},
      isTokenRefreshedMoreThanOnce: false,
      refreshingToken$t: null,
      checkingAuthStatus$i: null
    }
  },
  watch: {
    statusCheckSession: function (now) {
      if (now === 'successful') {
        this.onRefreshTokenSuccess()
      }
    },
    statusHandleAuthentication: function (now) {
      // if (now === 'successful' || now === 'failed') {
      // when it is failed, it should show ERROR page without proceeding any step further
      if (now === 'successful') {
        if (
          this.$router.currentRoute.name === 'Callback'
        ) {
          this.$logger.info('statusHandleAuthentication: Callback: Authenticated action')
          this.proceedRouting()
          this.initRefreshingTokenTimeout()
        }
      }
    }
  },
  created: function () {
    this.request = this.$param.options
    this.$param.checkCHeKTParams().then(
      paramReplaced => {
        // do nothing because it will reload the page and need to wait... because of async calls.
      },
      noParamToReplace => {
        if (this.$router.currentRoute.name === 'Callback') {
          // If it is Callback... Don't refresh token, because it has already got it by parsing hash query
          // initRefreshingTokenTimeout will occurs when statusHandleAuthentication === 'successful'
        } else {
          this.init()
        }
      }
    )
  },
  methods: {
    init: function () {
      // SPEC
      // 1. IP authentication can co-exist with user auth session
      // 2. IP authentication doesn't store its session in cookie (volatile)
      // INFO
      this.$logger.info('MyAuth: Has existing USER auth session')
      // [IP authentication]
      if (this.$route.query['ip_auth_dealer']) {
        this.$logger.info('MyAuth: IP authentication')
        this.refreshToken()
      // [User authentication]
      } else {
        this.$logger.info('MyAuth: User authentication')
        this.refreshToken()
      }
    },
    proceedRouting: function () {
      if ('request' in this.request) {
        if (this.request['request'] === 'dealer_registration') {
          this.$router.push({name: 'DealerTools', query: this.$route.query})
          return
        } else if (this.request['request'] === 'dealer_member_invitation') {
          this.$router.push({name: 'DealerTools', query: this.$route.query})
          return
        } else if (this.request['request'] === 'site_member_invitation') {
          this.$router.push({name: 'CustomerTools', query: this.$route.query})
          return
        }
      }

      if (this.request['continue']) {
        this.$tool.redirectToUrl(this.request['continue'])
        return
      }

      if (
        this.$router.currentRoute.name === 'Loading' ||
        this.$router.currentRoute.name === 'Login' ||
        this.$router.currentRoute.name === 'Logout' ||
        this.$router.currentRoute.name === 'Callback' ||
        this.$router.currentRoute.name === null
      ) {
        this.$router.push({name: 'Profile', query: this.$route.query})
      }
    },
    onLoginSuccess: function () {
      this.proceedRouting()
    },
    onRefreshTokenSuccess: function () {
      this.proceedRouting()
    },
    onCheckSessionError: function (err) {
      let errMessage = JSON.stringify(err)
      if (err.error === 'login_required') {
        if (this.isTokenRefreshedMoreThanOnce) {
          alert('Login required: Login session timeout.')
        }
        this.login()
      } else {
        this.$logger.error(errMessage)
        if (this.$route.query['ip_auth_dealer']) {
          alert(errMessage)
        } else {
          alert(errMessage)
        }
        if (confirm('Do you want to try login again?')) {
          this.login()
        } else {
          // do nothing
        }
      }
    },
    checkSession: function () {
      let dealerID = null
      if (this.$route.query['ip_auth_dealer']) {
        dealerID = this.$route.query['ip_auth_dealer']
      }
      // IP authentication - Treat this as infinite session
      if (dealerID) {
        return this.$store.dispatch('getIDTokenIPAuth', {dealerID})
      // Username/Password authentication
      } else {
        return this.$store.dispatch('checkSession')
      }
    },
    refreshToken: function () {
      this.checkSession().then(
        success => {
          this.$logger.info('refreshToken: Authenticated user')
          this.isTokenRefreshedMoreThanOnce = true
          this.proceedRouting()
          this.initRefreshingTokenTimeout()
        },
        err => {
          this.$logger.info('refreshToken: Not authenticated user: ' + err.error)
          this.onCheckSessionError(err)
        }
      )
    },
    initRefreshingTokenTimeout: function () {
      this.cancelRefreshingTokenTimeout()
      let timeoutAfter = 0
      if (this.idTokenExpiresAt) {
        timeoutAfter = (this.idTokenExpiresAt - (new Date()).getTime()) - (1 * 60 * 1000) // 1 min before expiration
      }
      this.$logger.info('initRefreshingTokenTimeout: Refreshing id token after {timeLeft} minutes.'.replace('{timeLeft}', '' + Math.round(timeoutAfter / 60000 + 0.5)))
      this.refreshingToken$t = setTimeout(() => {
        this.$logger.info('initRefreshingTokenTimeout: id token will be refreshed')
        this.checkSession().then(
          success => {
            this.$logger.info('initRefreshingTokenTimeout: Authenticated user')
            this.initRefreshingTokenTimeout()
          },
          err => {
            this.$logger.info('initRefreshingTokenTimeout: Not authenticated user: ' + JSON.stringify(err))
            this.onCheckSessionError(err)
          }
        )
      }, timeoutAfter)
      // startCheckingAuthStatus is used for when the computer wakes up after sleeping
      // it is a backing up feature for initRefreshingTokenTimeout
      // because initRefreshingTokenTimeout doens't work after sleeping
      setTimeout(() => { this.startCheckingAuthStatus() }, 1000)
    },
    cancelRefreshingTokenTimeout: function () {
      if (this.refreshingToken$t) {
        this.$logger.info('cancelRefreshingTokenTimeout: Canceling the previous timeout request')
        clearTimeout(this.refreshingToken$t)
      }
    },
    startCheckingAuthStatus: function () {
      let checkingInterval = 1000 * 10
      this.stopCheckingAuthStatus()
      this.$logger.info('startCheckingAuthStatus')
      this.checkingAuthStatus$i = setInterval(() => {
        if (!this.isAuthenticated()) {
          this.$logger.info('Check authenticated: No valid id_token!')
          this.refreshToken()
          this.stopCheckingAuthStatus()
        }
      }, checkingInterval)
    },
    stopCheckingAuthStatus: function () {
      this.$logger.info('stopCheckingAuthStatus')
      if (this.checkingAuthStatus$i) {
        clearInterval(this.checkingAuthStatus$i)
        this.checkingAuthStatus$i = null
      }
    },
    login: function () {
      if (this.$route.query['ip_auth_dealer']) {
        this.$tool.redirectToUrl(window.location.origin + window.location.search)
      } else {
        this.$store.dispatch('login')
      }
    },
    logout: function () {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/MyAuth.vue